import {
    CLOSE_MOBILE_MENU,
    CloseMobileMenuAction,
    OPEN_MOBILE_MENU,
    OpenMobileMenuAction,
    TOGGLE_MOBILE_MENU,
    ToggleMobileMenuAction,
} from './types';

export function toggleMobileMenu(): ToggleMobileMenuAction {
    return {
        type: TOGGLE_MOBILE_MENU,
    };
}

export function openMobileMenu(): OpenMobileMenuAction {
    return {
        type: OPEN_MOBILE_MENU,
    };
}

export function closeMobileMenu(): CloseMobileMenuAction {
    return {
        type: CLOSE_MOBILE_MENU,
    };
}
